// INR formatting with Indian numbering system (lakhs, crores)
export function formatINR(value, { decimals = 0, compact = false } = {}) {
  const num = Number(value || 0);
  if (compact) {
    const abs = Math.abs(num);
    if (abs >= 1e7) return `${num < 0 ? "-" : ""}₹${(abs / 1e7).toFixed(2)} Cr`;
    if (abs >= 1e5) return `${num < 0 ? "-" : ""}₹${(abs / 1e5).toFixed(2)} L`;
    if (abs >= 1e3) return `${num < 0 ? "-" : ""}₹${(abs / 1e3).toFixed(1)}K`;
    return `₹${num.toFixed(decimals)}`;
  }
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals,
  }).format(num);
}

export function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}
